import { Descriptions, Divider, Space } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { OneButton, OneModal, OneSecondaryButton } from '@yy/one-ui'
import AddressItem from '@/components/AddressInfo/components/AddressItem'
import { MESSAGE_RESOURCE } from '@/constant'
import { cancleCallPickup } from '@/services/apis'
import { useDispatch, useSelector } from '@/store'
import { notificationActions } from '@/store/notificationSlice'
import styles from './index.module.less'

const configMap = {
  couriers_please: {
    hideItems: ['state'],
    hideCanecl: true,
  },
} as const

const PickupDetail: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const noticePickupInfo = useSelector((state) => state.notification?.noticePickupInfo) || {}
  const providerDic = useSelector((state) => state.dictionary.providerDic)

  const detail = useMemo(() => noticePickupInfo?.pickupInfo || {}, [noticePickupInfo?.pickupInfo])
  const taskInfo = noticePickupInfo?.taskInfo

  const displayConfig = configMap[detail.channelCode]

  const addressInfo = {
    country: detail?.pickupCountry,
    province: detail?.pickupProvince,
    city: detail?.pickupCity,
    district: detail?.pickupDistrict,
    town: detail?.pickupTown,
    addressOne: detail?.pickupAddress,
    addressTwo: detail?.pickupAddressTwo,
    name: detail?.pickupName,
    mobile: detail?.pickupMobile,
    zipCode: detail?.pickupZipCode,
  }
  // 取消揽收
  const handleCancelPickup = useCallback(async () => {
    await cancleCallPickup({ id: detail.id })
    dispatch(notificationActions.setPickupInfo({ isShow: false, pickupInfo: {} }))
  }, [detail, dispatch])

  const handleOk = useCallback(() => {
    dispatch(notificationActions.setPickupInfo({ isShow: false, pickupInfo: {} }))
  }, [dispatch])

  const footerBtn = useMemo(() => {
    return (
      <Space>
        {taskInfo?.msgSource === MESSAGE_RESOURCE.callPickup && !displayConfig?.hideCanecl && (
          <OneSecondaryButton onClick={handleCancelPickup}>{t('order.list.pickUp.cancel')}</OneSecondaryButton>
        )}
        <OneButton onClick={handleOk} type="primary">
          {t('common.finish')}
        </OneButton>
      </Space>
    )
  }, [handleCancelPickup, handleOk, taskInfo?.msgSource, t, displayConfig?.hideCanecl])

  return (
    <OneModal title={t('order.list.pickUp.detail')} footer={footerBtn} visible={noticePickupInfo.isShow} onCancel={handleOk} width={860}>
      <div className={styles.container}>
        <Descriptions colon={false}>
          <Descriptions.Item label={t('logistics.detail.senderName')}>{detail.pickupName}</Descriptions.Item>
          <Descriptions.Item label={t('courier.service')}>
            <div className="flex align_c">
              {providerDic[detail.providerCode]?.url && <img src={providerDic[detail.providerCode].url} style={{ width: '24px', height: '24px', marginRight: '4px' }} />}
              {detail.providerName}
            </div>
          </Descriptions.Item>
          <Descriptions.Item label={t('order.list.pickUp.nums')}>{detail.pickupNumber}</Descriptions.Item>
          <Descriptions.Item label={t('pickup.totalCommodityNum')}>{detail.pickupTotalCommodityNum}</Descriptions.Item>
          <Descriptions.Item label={t('common.totalWeight')}>{detail.pickupTotalWeight}kg</Descriptions.Item>
        </Descriptions>
        <AddressItem address={addressInfo} />
        <Descriptions colon={false} style={{ marginTop: '8px' }}>
          <Descriptions.Item label={t('order.create.remarks')}>{detail.pickupRemark}</Descriptions.Item>
        </Descriptions>
        <Divider dashed style={{ margin: '16px 0 24px' }} />
        <Descriptions colon={false} column={3} labelStyle={{ minWidth: '100px' }}>
          {detail?.ticketPickupId ? <Descriptions.Item label={t('pickup.detail.pickupId')}>{detail?.ticketPickupId}</Descriptions.Item> : null}
          <Descriptions.Item label={t('order.list.pickUp.code')}>{detail?.currentPickupCode}</Descriptions.Item>
          {displayConfig?.hideItems?.includes('state') ? null : detail?.state || detail?.state === 0 ? (
            <Descriptions.Item label={t('common.status')}>{t(`pickup.detail.status.${detail?.state}`)}</Descriptions.Item>
          ) : null}
        </Descriptions>
        {detail?.staffInfoName || detail?.staffInfoId || detail?.staffInfoPhone ? (
          <Descriptions colon={false} column={3} labelStyle={{ minWidth: '100px' }}>
            <Descriptions.Item label={t('pickup.detail.staffInfoName')}>{detail?.staffInfoName}</Descriptions.Item>
            <Descriptions.Item label={t('pickup.detail.staffInfoId')}>{detail?.staffInfoId}</Descriptions.Item>
            <Descriptions.Item label={t('address.form.phone')}>{detail?.staffInfoPhone}</Descriptions.Item>
          </Descriptions>
        ) : null}
        <Descriptions colon={false} column={1} labelStyle={{ minWidth: '100px' }}>
          <Descriptions.Item label={t('order.list.pickUp.time')}>{detail.pickupTime}</Descriptions.Item>
          <Descriptions.Item label={t('order.list.pickUp.remind')}>{detail.notice}</Descriptions.Item>
          {detail.ticketMessage ? <Descriptions.Item label={t('order.create.remarks')}>{detail.ticketMessage}</Descriptions.Item> : null}
          {detail.cancelReasonText ? <Descriptions.Item label={t('pickup.detail.cancelReason')}>{detail.cancelReasonText}</Descriptions.Item> : null}
          <Descriptions.Item label={t('order.list.pickUp.updateTime')}>{detail.updateTime}</Descriptions.Item>
        </Descriptions>
      </div>
    </OneModal>
  )
}

PickupDetail.displayName = 'PickupDetail'
export default PickupDetail
